import camelCase from 'lodash/camelCase';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { ForPaintSoftwareProjectSidebar as AsyncForPaintSidebarNextGen } from '@atlassian/jira-navigation-apps-sidebar-next-gen/src/async.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { createLayout } from '@atlassian/jira-route-layout/src/GlobalComponent.tsx';
import { softwareInboxNextGenRoute } from '@atlassian/jira-router-routes-software-inbox-routes/src/softwareInboxNextGenRoute.tsx';
import { AsyncHorizontalNavJira } from '@atlassian/jira-horizontal-nav/src/async.tsx';
import { softwareProjectLayoutNoOnboarding } from '@atlassian/jira-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { InboxViewTableSkeleton } from '@atlassian/jira-skeletons/src/ui/customer-service/inbox-view-table/components/InboxViewTableSkeleton.tsx';
import { notFoundPageEntrypoint } from '@atlassian/jira-router-routes-not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getCommonProjectResources } from '@atlassian/jira-router-routes-issue-navigator-entries/src/common/getCommonProjectResources.tsx';
import { inboxPageEntryPoint } from './ui/index.tsx';

export const softwareInboxNextGenRouteEntry: Route = createEntry(softwareInboxNextGenRoute, () => ({
	group: 'software',

	meta: {
		reporting: {
			id: 'software-inbox-classic',
			packageName: camelCase('software-inbox-classic'),
			teamName: 'boysenberry',
		},
	},

	skeleton: InboxViewTableSkeleton,

	navigation: {
		menuId: MENU_ID.PROJECTS,
		sidebar: AsyncForPaintSidebarNextGen,
		horizontal: AsyncHorizontalNavJira,
	},

	resources: [...getCommonProjectResources()],
	layout: createLayout(softwareProjectLayoutNoOnboarding),

	entryPoint: () =>
		fg('jcs_developer_escalations') ? inboxPageEntryPoint : notFoundPageEntrypoint,

	supportsPreviewPanel: true,

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-software-inbox-entries/src/softwareInboxNextGenRouteEntry.tsx',
			whichExportToUse: 'softwareInboxNextGenRouteEntry',
		},

		enabled: true,
	},
}));
